import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import HtmlView from "component/htmlView/html-view";

function VisualizationMeta({
  currentLocale,
  visualizationDetails,
  visualization,
  colHeaders,
  indicatorPublication,
}) {
  const intl = useIntl();

  if (visualizationDetails.isLoading || visualizationDetails.error) {
    return (
      <div className="text-center" dir="ltr">
        <h5>{intl.formatMessage({ id: "loading..." })}</h5>
      </div>
    );
  }

  return (
    <div className="row gx-md-2 gx-0 gy-2">
      <div className="col-lg-3 col-md-6">
        <div className="item-box-content">
          <h6>
            <FormattedMessage id="unit" />:
          </h6>
          <span>
            {visualization?.measureUnit ? (
              <LabelLang
                id="name"
                defaultValue={visualization.measureUnit.name}
                translations={
                  visualization.measureUnit.measureUnitTranslations
                }
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="item-box-content">
          <h6>
            <FormattedMessage id="periodic" />:
          </h6>
          <span>
            {visualization?.periodic ? (
              <LabelLang
                id="name"
                defaultValue={visualization.periodic.name}
                translations={visualization.periodic.periodicTranslations}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="item-box-content">
          <h6>
            <FormattedMessage id="start-period" />:
          </h6>
          <span>
            {colHeaders[1]?.headerName ? (
              colHeaders[1].headerName
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="item-box-content">
          <h6>
            <FormattedMessage id="end-period" />:
          </h6>
          <span>
            {colHeaders[colHeaders?.length - 1]?.headerName ? (
              colHeaders[colHeaders.length - 1].headerName
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      </div>
      <div className="col-12">
        <div className="item-box-content">
          <h6>
            <FormattedMessage id="main-source" />:
          </h6>
          <span>
            <Link to={`/publications/${indicatorPublication?.id}`}>
              {`${intl.formatMessage({ id: "agency" })} -
              ${LabelLangString({
                id: "name",
                currentLocale,
                defaultValue: indicatorPublication?.name,
                translations: indicatorPublication?.publicationTranslations,
              })}
              `}
            </Link>
          </span>
        </div>
      </div>
      <div className="col-12">
        <div className="item-box-content mb-4">
          <h6>
            <FormattedMessage id="statistical-notes" />:
          </h6>
          <span>
            {visualization?.notes ? (
              <HtmlView
                html={LabelLangString({
                  id: "notes",
                  currentLocale,
                  defaultValue: visualization.notes,
                  translations: visualization.indicatorTranslations,
                })}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      </div>
    </div>
  );
}

export default VisualizationMeta;
